import React, { useState, useEffect, useRef } from "react";
import SubFilterCustom from "./components/SubFilterCustom/index.jsx";
import { getCategoriaData } from "./services/subFilterService.jsx";
import SubFilteBotonTodos from "./components/SubFilteBotonTodos/SubFilteBotonTodos.jsx";
import useIsTouchDevice from "../../../../../../../hooks/useIsTouchDevice.jsx";

export default function SubFilter({
  vCategoriesSelected = [],
  setVCategoriesSelected = () => {},
}) {
  const [vCategorias, setVCategorias] = useState([]);
  const [isScrolling, setIsScrolling] = useState(false);
  const boxFiltroBotonRef = useRef(null);
  let scrollTimeout;

  const { isTouch: isTouchDevice, isLoading } = useIsTouchDevice();

  const mGetCategoriasFetch = () => {
    getCategoriaData()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          switch (result["detail"]["acción"]) {
            case "CATEGORIAS_OBTENIDAS":
              setVCategorias(result["detail"]["datos"]);
              console.log(result["detail"]["datos"]);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      });
  };

  useEffect(() => {
    mGetCategoriasFetch();
  }, []);

  useEffect(() => {
    const boxFiltroBoton = boxFiltroBotonRef.current;
    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDownHandler = (e) => {
      isDown = true;
      clearTimeout(scrollTimeout);
      boxFiltroBoton.classList.add("active");
      startX = e.pageX - boxFiltroBoton.offsetLeft;
      scrollLeft = boxFiltroBoton.scrollLeft;
    };

    const mouseLeaveHandler = () => {
      isDown = false;
      boxFiltroBoton.classList.remove("active");
      scrollTimeout = setTimeout(() => setIsScrolling(false), 100);
    };

    const mouseUpHandler = () => {
      isDown = false;
      boxFiltroBoton.classList.remove("active");
      scrollTimeout = setTimeout(() => setIsScrolling(false), 100);
    };

    const mouseMoveHandler = (e) => {
      if (!isDown) return;
      e.preventDefault();
      setIsScrolling(true);
      const x = e.pageX - boxFiltroBoton.offsetLeft;
      const walk = (x - startX) * 1; // Adjusted scroll speed
      boxFiltroBoton.scrollLeft = scrollLeft - walk;
    };

    //if (!isLoading && !isTouchDevice) {
    boxFiltroBoton.addEventListener("mousedown", mouseDownHandler);
    boxFiltroBoton.addEventListener("mouseleave", mouseLeaveHandler);
    boxFiltroBoton.addEventListener("mouseup", mouseUpHandler);
    boxFiltroBoton.addEventListener("mousemove", mouseMoveHandler);
    //}
    return () => {
      boxFiltroBoton.removeEventListener("mousedown", mouseDownHandler);
      boxFiltroBoton.removeEventListener("mouseleave", mouseLeaveHandler);
      boxFiltroBoton.removeEventListener("mouseup", mouseUpHandler);
      boxFiltroBoton.removeEventListener("mousemove", mouseMoveHandler);
    };
  }, [isTouchDevice, isLoading]);

  return (
    <>
      <div class="cursos-filtros">
        <SubFilteBotonTodos
          setVCategoriesSelected={setVCategoriesSelected}
          vCategoriesSelected={vCategoriesSelected}
        />
        <div className="box-filtro-boton" ref={boxFiltroBotonRef}>
          {console.log("vCategoriesSelected actual:", vCategoriesSelected)}
          {vCategorias.map((vCartegoria) => {
            const isSelected = vCategoriesSelected.includes(vCartegoria.id);

            console.log("Renderizando categoría:", {
              id: vCartegoria.id,
              nombre: vCartegoria.nombre,
              isSelected,
            });

            return (
              <SubFilterCustom
                vIsSelected={isSelected}
                setVCategoriesSelected={setVCategoriesSelected}
                vCategoriaProp={vCartegoria}
                isScrolling={isScrolling}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
